import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import type { NotificationEvent } from '@cardapio-online/notifications';
import { NotificationStore } from '@cardapio-online/notifications';

@Component({
  selector: 'lib-ui-notification-list',
  templateUrl: './ui-notification-list.component.html',
  styleUrl: './ui-notification-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiNotificationListComponent {
  private readonly notificationStore = inject(NotificationStore);
  private readonly router = inject(Router);

  @Input() notifications: NotificationEvent[] = [];
  @Input() compact = false;
  @Input() showHeader = true;
  @Input() showActions = true;
  @Input() title = 'Notificacoes';
  @Input() emptyTitle = 'Tudo em ordem';
  @Input() emptyDescription =
    'As proximas notificacoes em tempo real vao aparecer aqui.';
  @Output() orderOpened = new EventEmitter<NotificationEvent>();

  protected markAllAsRead(): void {
    this.notificationStore.markAllAsRead();
  }

  protected clearAll(): void {
    this.notificationStore.clear();
  }

  protected openNotification(notification: NotificationEvent): void {
    if (this.hasOrderAction(notification)) {
      this.openOrder(notification);
      return;
    }

    this.notificationStore.markAsRead(notification.id);

    if (notification.route) {
      void this.router.navigateByUrl(notification.route);
    }
  }

  protected hasOrderAction(notification: NotificationEvent): boolean {
    return notification.eventType === 'order.created' && !!notification.orderId;
  }

  protected openOrder(notification: NotificationEvent): void {
    if (!this.hasOrderAction(notification) || !notification.orderId) {
      this.openNotification(notification);
      return;
    }

    const routeUrl = notification.route || '/admin/pedidos/lista';

    this.notificationStore.remove(notification.id);
    this.orderOpened.emit(notification);
    void this.router.navigateByUrl(
      `${routeUrl}?openOrderId=${encodeURIComponent(notification.orderId)}`
    );
  }
}
